import * as React from 'react'

import { mq, spacing, styled } from '@thg-commerce/enterprise-theme'

const HorizontalScrollWrapper = styled.div`
  margin-right: ${spacing(-2)};
  margin-left: ${spacing(-1)};
`
const ProductList = styled.ul`
  width: 100%;
  list-style: none;
  margin: 0;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: calc(100% / 2);
  overflow-x: auto;
  overflow-y: hidden;

  scrollbar-width: thin;
  scrollbar-color: ${(props) => props.theme.colors.palette.brand.light} ${(
  props,
) => props.theme.colors.palette.brand.darkest}

  &::-webkit-scrollbar {
    height: 14px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.palette.brand.light};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color:  ${(props) => props.theme.colors.palette.brand.darkest};
    border-radius: 8px;
    border: 2px solid ${(props) => props.theme.colors.palette.brand.darkest};
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${(props) => props.theme.colors.palette.brand.darkest};
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    grid-auto-columns: calc(100% / 4);
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    grid-auto-columns: calc(100% / 5);
  }

  > li {
  padding-left: 8px;
  padding-right: 0px;
}
`

interface ProductListScrollerProps {
  productBlocks?: JSX.Element[]
}

export const ProductListScoller = (props: ProductListScrollerProps) => {
  return (
    <HorizontalScrollWrapper>
      <ProductList>{props.productBlocks}</ProductList>
    </HorizontalScrollWrapper>
  )
}
